import React from "react";

// Cap input below the DB's decimal(18,2) limit and well within JS Number
// precision. Six digits also keeps the GBP entry-price input at a sane
// human-meaningful range (GBP 999,999).
export const MAX_OFFER_AMOUNT = 999999;

interface CounterProps {
  amount: number;
  onIncrement: () => void;
  onDecrement: () => void;
  onAmountChange: (amount: number) => void;
  disabled?: boolean;
  maxAmount?: number;
}

const Counter: React.FC<CounterProps> = ({
  amount,
  onIncrement,
  onDecrement,
  onAmountChange,
  disabled = false,
  maxAmount = MAX_OFFER_AMOUNT,
}) => {
  const handleAmountChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const nextValue = event.target.value;

    if (nextValue === "") {
      onAmountChange(0);
      return;
    }

    if (!/^\d+$/.test(nextValue)) {
      return;
    }

    const parsed = Number(nextValue);
    if (parsed > maxAmount) {
      onAmountChange(maxAmount);
      return;
    }

    onAmountChange(parsed);
  };

  return (
    <div className="align-content-center justify-content-start d-flex col">
      <button className="counterBtn" onClick={onDecrement} disabled={disabled}>
        -
      </button>
      <span className="yellowTxt col-auto d-flex m-1 align-items-center">
        <p className="m-1">GBP</p>
        <input
          className="counter m-1 bg-transparent border-0 yellowTxt"
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={String(maxAmount).length}
          value={amount}
          onChange={handleAmountChange}
          disabled={disabled}
          style={{ width: "90px" }}
        />
      </span>
      <button className="counterBtn" onClick={onIncrement} disabled={disabled}>
        +
      </button>
    </div>
  );
};

export default Counter;
